import { createReducer, on } from "@ngrx/store";
import { addUserEvent, clearUserEvents } from "../actions/user-events.actions";
import { userEventsInitialState } from "../initial-states/user-events.state";

export const UserEventsReducer = createReducer(userEventsInitialState,

	// The reducer runs when a dispatch 'addUserEvent' was triggered
	// The only thing we need to do here is add the event to the event list
	on(addUserEvent,
		(state, { event }) => ({
            ...state, // Copy the existing state
            userEvents: [...state.userEvents, event] 
		}),
	),

	// The reducer runs when a dispatch 'clearUserEvents' was triggered
	// The only thing we need to do here is empty the event list
	on(clearUserEvents,
		(state) => ({
            ...state, // Copy the existing state
            userEvents: [] 
		}),
	),
)